<template lang="pug">
  .avatar-stack
    .avatar(v-for="(a, i) in avatars" :key="i" :style="`z-index: ${i}`")
      img(:src="a")
    //.avatar
      img(:src="fam.adult.avatar" key="2" :style="`z-index: 2`")
    //.avatar(v-for="i in 4" :key="i" :style="`z-index: ${i}`")
      img(src="~assets/avatar.png")


</template>
<script>
import { mapGetters, mapState } from 'vuex'
import avatarNull from 'src/assets/avatar-null.svg'
import avatarDefault from 'src/assets/avatar-default.png'
export default {
  name: 'AvatarStack',
  props: {
    //avatars: {},
    noMe: {
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user', 'fam']),
    //...mapGetters('app', ['getAdultAdded', 'getChildrenAdded']),
    avatars() {
      let avatars = []
      if (this.user.famUsers.length < 2) {
        avatars.push(avatarDefault)
        return avatars
      }
      this.user.famUsers.map((u) => {
        if (this.noMe && u.id === this.user.id) {
        } else {
          if (u.userType === 0) {
            if (u.avatar) {
              avatars.push(u.avatar)
            } else {
              avatars.push(avatarDefault)
            }
          } else {
            avatars.push(avatarDefault)
          }
        }
      })
      return avatars
    },
  },
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.avatar-stack
  display: flex
  justify-content: flex-start
  align-items: center
  flex-direction: row
  margin-left: pxToRem(25)
  .avatar
    position: relative
    margin-left: pxToRem(-25)
    width: pxToRem(60)
    height: pxToRem(60)
    box-shadow: pxToRem(-10) pxToRem(-10) pxToRem(17) 0 rgba(255,255,255,0.02), pxToRem(-19) pxToRem(-10) pxToRem(23) 0 rgba(252,252,252,0.74), pxToRem(-12) pxToRem(8) pxToRem(17) 0 rgba(252,252,252,0.35), pxToRem(2) pxToRem(13) pxToRem(43) 0 rgba(228,228,228,0.80)
    border-radius: pxToRem(30)
    border: pxToRem(3) #fff solid
    overflow: hidden
    line-height: 0
    img
      width: 100%
      height: 100%
</style>
